export const API_LOCAL_BASE_URL =
  process.env.REACT_APP_API_LOCAL_URL || "https://localhost:44341/";
export const SHOPIFY_LOGIN_URL =
  process.env.SHOPIFY_LOGIN_URL || "https://oolalife.com/account/login/";
export const SLACK_WEBHOOK_URL =
  process.env.REACT_APP_SLACK_WEBHOOK_URL ||
  "https://hooks.slack.com/services/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";
